export default {
  methods: {
    getAddressComponents(address_components) {
      const address = {};
      if (address_components && address_components.length > 0) {
        let administrative_area_level_1;
        let administrative_area_level_2;
        let administrative_area_level_3;
        let locality;
        let route;
        let street_number;

        for (let i = 0; i < address_components.length; i++) {
          let component = address_components[i];
          let name = component['long_name'];
          let types = component['types'];

          if (this.contains(types, 'postal_code') >= 0) {
            address.postalCode = name;
          } else if (this.contains(types, 'country') >= 0) {
            address.country = name;
          } else if (this.contains(types, 'locality') >= 0) {
            locality = name;
          } else if (this.contains(types, 'administrative_area_level_1') >= 0) {
            administrative_area_level_1 = name;
          } else if (this.contains(types, 'administrative_area_level_2') >= 0) {
            administrative_area_level_2 = name;
          } else if (this.contains(types, 'administrative_area_level_3') >= 0) {
            administrative_area_level_3 = name;
          } else if (this.contains(types, 'route') >= 0) {
            route = name;
          } else if (this.contains(types, 'street_number') >= 0) {
            street_number = name;
          }
        }

        if (route && street_number) {
          address.street = route + ' ' + street_number;
        } else if (route) {
          address.street = route;
        }

        if (administrative_area_level_3) {
          address.city = administrative_area_level_3;
        } else if (administrative_area_level_2) {
          address.city = administrative_area_level_2;
        } else if (administrative_area_level_1) {
          address.city = administrative_area_level_1;
        } else if (locality) {
          address.city = locality;
        }
      }

      return address;
    },

    contains(arr, word) {
      return arr.findIndex((e) => e === word);
    },
  },
};
